import React from 'react';
import img from '../../Images/profile.jpeg';
import './AboutMe.css';

const AboutMe = () => {
    return (
        <div id="about">
            <div className="about section-container">
                <div className="col-left">
                    <div className="about-img">
                        <img src={img} alt="img" />
                    </div>
                </div>
                <div className="col-right">
                    <h1 className="section-title mb-5">About <span>me</span></h1>
                    <h2>Front End Web Developer</h2>
                    <p>A confident, self-learner, hard-working person is eager to enrich the expertise and experiences for the betterment of the working sectors. Passionate about design and developing new technology and solving new issues.</p>
                    <p>Recently I have completed my graduation on Computer Science and Engineering from Daffodil International University. I gathered many knowledge and faced many new new experiences throughout my university career. I placed 11th position in Take-off Programming Contest from my university in 2018.</p>
                    <p>Finished schooling from Natural Gas Fertilizer Factory School in 2014 and higher secondary from Scholarshome College in 2016.</p>
                    <p>So far I have learned many web technologies like HTML, CSS, JavaScript, React JS, a little bit of Node JS, MongoDB and some little bit of knowledge about another web tools, frameworks, libraries.</p>
                    <a href="https://drive.google.com/file/d/1-qtS2D4YI6pdX-1lS6IdTmHFXRZ9zFNC/view?usp=sharing" target="_blank" rel="noreferrer" type="button" className="cta">Download Resume</a>
                </div>
            </div>
        </div>
    );
};

export default AboutMe;